export const GET_MENU_LIST_SUCCES = 'GET_MENU_LIST_SUCCESS';
export const GET_MENU_LIST_FAILED = 'GET_MENU_LIST_FAILED';
export const GET_MENU_LIST_REQUEST = 'GET_MENU_LIST_REQUEST';
